/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, Input } from '@angular/core';
import { LuxonModule } from 'luxon-angular';

@Component({
    selector: 'dash-gis-date-field',
    templateUrl: './date-field.component.html',
    styleUrls: [ './date-field.component.scss' ],
    imports: [ LuxonModule ]
})
export class DateFieldComponent {
    @Input() public rowData: any;
    @Input() public fieldDefinition: any;
}
